import useToaster from "./useToaster";

export default function useOverlayTemplates() {
  const { addToaster } = useToaster();
  const baseUrl = process.env.REACT_APP_API_URL || "";
  const apiUrl = `${baseUrl}/api/overlay-templates`;

  const safeFetch = async (endpoint, options = {}) => {
    try {
      const token = localStorage.getItem("x-token");
      const headers = {};

      if (!(options.body instanceof FormData))
        headers["Content-Type"] = "application/json";
      headers["Authorization"] = `Bearer ${token}`;

      if (options.headers) Object.assign(headers, options.headers);

      const response = await fetch(endpoint, { ...options, headers });

      if (response.status === 401) window.dispatchEvent(new Event("auth-logout"));
      const data = await response.json();
      if (data && data.error) throw new Error(data.error);
      return data;
    } catch (error) {
      console.error("API request failed:", error.message);
      addToaster({ message: `${error?.message || JSON.stringify(error)}`, severity: "error" });
      throw error;
    }
  };

  const list = () => safeFetch(apiUrl);

  const get = (id) => safeFetch(`${apiUrl}/${id}`);

  const create = (template) =>
    safeFetch(apiUrl, {
      method: "POST",
      body: JSON.stringify(template),
    });

  const update = (id, template) =>
    safeFetch(`${apiUrl}/${id}`, {
      method: "PUT",
      body: JSON.stringify(template),
    });

  const remove = (id) =>
    safeFetch(`${apiUrl}/${id}`, { method: "DELETE" });

  const uploadLogo = (templateId, elementId, file) => {
    const formData = new FormData();
    formData.append("logo", file);
    return safeFetch(`${apiUrl}/${templateId}/elements/${elementId}/logo`, {
      method: "POST",
      body: formData,
    });
  };

  return { list, get, create, update, remove, uploadLogo };
}
